import { notification } from "antd";
import { useCallback } from "react";
import { SubmitHandler } from "react-hook-form";
import { SchemaFormUser } from "../../../../components/forms/FormUser";
import {
  useUserCreateMutation,
  useUserDeleteMutation,
  useUserUpdateMutation,
} from "../../apiSlice";
import { getErrorMessage } from "../../../../utils/errors/errors";
import { FetchUsersQuery } from "../../../../types/reactQueries";

export const useCrudUser = (
  userId: 0 | number,
  fetchUsers: FetchUsersQuery,
  search: string,
  onHideModal: () => void,
) => {
  const [lazyCreateUser, { isLoading: isCreating }] = useUserCreateMutation();
  const [lazyUpdateUser, { isLoading: isUpdating }] = useUserUpdateMutation();
  const [lazyDeleteUser, { isLoading: isDeleting }] = useUserDeleteMutation();

  const createUser: SubmitHandler<SchemaFormUser> = useCallback(
    async (values) => {
      console.log("Submit createUser", values);
      try {
        // const mockedData = {
        //   fullname: "CRUD Test",
        //   email: "test2@test.fr",
        //   company: "CRUD Test - Company",
        //   isExternal: true,
        //   cached_role: 1,
        // };

        const formattedValues = {
          ...values,
          cached_role: Number(values.cached_role),
        };

        // Create user
        await lazyCreateUser(formattedValues).unwrap();

        // Show success notification
        notification.success({
          message: "Utilisateur crÃ©Ã©",
          description: `L'utilisateur ${values.fullname} a Ã©tÃ© crÃ©Ã© avec succÃ¨s.`,
        });

        // Hide modal
        onHideModal();

        // Re-fetch users
        await fetchUsers(`search=${search}`).unwrap();
      } catch (e: unknown) {
        console.log("createUser error", e);
        notification.error({
          message: "Erreur",
          description: getErrorMessage(e),
        });
      }
    },
    [lazyCreateUser, fetchUsers, search, onHideModal],
  );

  const updateUser: SubmitHandler<SchemaFormUser> = useCallback(
    async (values) => {
      try {
        console.log("Submit updateUser", userId, values);

        const formattedValues = {
          ...values,
          cached_role: Number(values.cached_role),
          // Trigger error
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          //   cached_role: {
          //     bad: true,
          //   },
        };

        await lazyUpdateUser({
          userId: String(userId),
          values: formattedValues,
        }).unwrap();

        // Show success notification
        notification.success({
          message: "Utilisateur modifiÃ©",
          description: `L'utilisateur ${values.fullname} a Ã©tÃ© modifiÃ© avec succÃ¨s.`,
        });

        // Hide modal
        onHideModal();

        // Re-fetch users
        await fetchUsers(`search=${search}`).unwrap();
      } catch (e: unknown) {
        console.log("updateUser error", e);
        notification.error({
          message: "Erreur",
          description: getErrorMessage(e),
        });
      }
    },
    [userId, lazyUpdateUser, onHideModal, fetchUsers, search],
  );

  const onDelete = useCallback(
    async (id: number) => {
      try {
        console.log("deleteUser user id:", id);
        // Delete user
        await lazyDeleteUser(id).unwrap();

        // Show success notification
        notification.success({
          message: "Utilisateur supprimÃ©",
          description: `L'utilisateur a Ã©tÃ© supprimÃ© avec succÃ¨s.`,
        });

        // Re-fetch users
        await fetchUsers().unwrap();
      } catch (e: unknown) {
        console.log("deleteUser error", e);
        notification.error({
          message: "Erreur",
          description: getErrorMessage(e),
        });
      }
    },
    [fetchUsers, lazyDeleteUser],
  );

  return {
    createUser,
    isCreating,
    updateUser,
    isUpdating,
    onDelete,
    isDeleting,
  };
};
